import { getFacility } from "../store/reducers/domain/facilities";
import { loadAuditMarkingReports, loadHousekeepingReports } from "../store/reducers/domain/housekeeping";
import store from "../store/store";
import asyncTaskWatcher from "./asyncTaskWatcher";
import { authProvider } from "./auth/AuthProvider";
import log from "./logging";

// This is the main app hub events for any signalR events broadcasted
const registerAppEvents = ({
  updateHousekeepingReport,
}: {
  updateHousekeepingReport: (facilityId: string) => void;
}) => {
  const connection = asyncTaskWatcher.getConnection();
  if (!connection) {
    log.error('Cannot register chat events: connection is not initialized. Call startChatHubConnection first.');
    return;
  }

  connection.on("UpdateHousekeepingReport", updateHousekeepingReport);
};

const updateHousekeepingReport = (facilityId: string) => {
  log.info('Facility Housekeeping report requires update', facilityId);

  // just adding a guard that the user is still within the same facility
  if (facilityId !== authProvider.getAccountInfo()?.facility?.id) return;

  if (facilityId) {
    store.dispatch(loadHousekeepingReports({ LatestRoomHistory: true })).then(r => {
      if (!loadHousekeepingReports.fulfilled.match(r)) {
        throw r.error;
      }

      return store.dispatch(getFacility(facilityId))
    })
      .then(r => {
        if (!getFacility.fulfilled.match(r)) {
          throw r.error;
        }

        return store.dispatch(loadAuditMarkingReports({ latestRoomHistory: true }));
      })
  }
}
const unregisterAppEvents = () => {
  const connection = asyncTaskWatcher.getConnection();
  if (!connection) return;

  connection.off("UpdateHousekeepingReport");
};

const hubAppEvents = {registerAppEvents, unregisterAppEvents, updateHousekeepingReport};

export default hubAppEvents;